<template>
    <div class="np-form-services">
        <div class="np-form-services__list">
            <div
                class="np-form-services__list-el vue-open-invoice-pay"
                @click="$emit('closePopup')"
            >
                Оплата по ID счета
            </div>
            <div class="np-form-services__list-el"
                v-for="service in stepOneData"
                 @click="$emit('select-service', service)"
            >
                {{ service.name }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "NewPaymentFormServices",
    props: {
        stepOneData: {
            type: Array,
        }
    },
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/mixins-and-vars';

$parent: '.np-form-services';

#{$parent} {
    display: flex;

    animation: ezTransformOpacity .2s linear;

    &__list {
        display: flex;
        flex-direction: column;
        width: 100%;

        &-el {
            position: relative;
            padding: 8px 0 8px 22px;
            color: $color-brand;
            font-size: 18px;
            cursor: pointer;
            transition: $transition;

            @include mobile {
                padding: 4px 0 4px 16px;
                font-size: 16px;
            }

            &:hover {
                color: $color-brand-hover;
            }

            &::before {
                position: absolute;
                content: '';
                left: 0;
                top: 13px;
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background: #78D4D1;

                @include mobile {
                    width: 5px;
                    height: 5px;
                    top: 10px;
                }
            }
        }
    }
}
</style>
